import Image from '@atlaskit/image';
import { css } from '@compiled/react';
import { ConfluenceBannerFirstPartyRecommendation } from '@post-office/components--confluence-banner-first-party-recommendation';
// @ts-expect-error: 'React' is declared but its value is never read
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';

import { createRender } from './types';
import JPD_LOGO_DARK from '../../../assets/jira-product-discovery-logo-dark.svg';
import JPD_LOGO_LIGHT from '../../../assets/jira-product-discovery-logo-light.svg';

const logoStyles = css({
	width: '110px',
	'@media (max-width: 820px)': {
		width: '100px',
	},
});

export const render = createRender(({ onDismissed }) => {
	const intl = useIntl();
	return (
		<ConfluenceBannerFirstPartyRecommendation
			app={{
				hamsIdentifier: 'jira-product-discovery',
				ccpProductId: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
				logo: (
					<Image
						css={logoStyles}
						src={JPD_LOGO_LIGHT}
						srcDark={JPD_LOGO_DARK}
						alt={intl.formatMessage({
							id: 'post-office.growth.recommendation-jpd.confluence-home-banner.logo-alt-text',
							description:
								'Alt text for the product logo in Jira Product Discovery recommendation message in Confluence Home Banner',
							defaultMessage: 'Jira Product Discovery Product Logo',
						})}
					/>
				),
				header: (
					<FormattedMessage
						id="post-office.growth.recommendation-jpd.confluence-home-banner.header"
						description="Header for Jira Product Discovery recommendation message in Confluence Home Banner"
						defaultMessage="Capture your ideas and customer feedback all in one place"
					/>
				),
				description: (
					<FormattedMessage
						id="post-office.growth.recommendation-jpd.confluence-home-banner.description"
						description="Description for Jira Product Discovery recommendation message in Confluence Home Banner"
						defaultMessage="Make sure your team is building the right things with Jira Product Discovery."
					/>
				),
			}}
			backgroundImage="arrows"
			onDismissed={onDismissed}
		/>
	);
});

export default render;
